import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import ServiceCard from "@/components/ServiceCard";
import { SectionHeading } from "@/components/Section";
import { Loader2 } from "lucide-react";

export default function Services() {
  const { t } = useI18n();
  const [services, setServices] = useState(null);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([]));
    api.get("/service-categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const filtered = services?.filter((s) => active === "all" || s.category === active) || [];

  return (
    <div className="section-lux grid-glow">
      <div className="container-lux">
        <SectionHeading label="Services" title={t("home.servicesTitle")} subtitle={t("home.servicesSub")} />
        <div className="mt-10 flex flex-wrap justify-center gap-2">
          <button onClick={() => setActive("all")} data-testid="service-filter-all"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${active === "all" ? "bg-gradient-to-r from-amber-400 to-amber-600 text-black" : "border border-amber-500/20 text-slate-300 hover:text-amber-400"}`}>
            {t("common.viewAll")}
          </button>
          {cats.map((c) => (
            <button key={c.id} onClick={() => setActive(c.name)} data-testid={`service-filter-${c.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${active === c.name ? "bg-gradient-to-r from-amber-400 to-amber-600 text-black" : "border border-amber-500/20 text-slate-300 hover:text-amber-400"}`}>
              {c.name}
            </button>
          ))}
        </div>
        {services === null ? (
          <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
